if (!customElements.get('bwr-artist-records')) {
  customElements.define('bwr-artist-records', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.loaded) return;
      this.controller = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.observer = null;
      this.loaded = false;
    }
    async load() {
      this.loaded = true;
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = html.querySelector('[data-artist-record-list]');
        if (!list) return;
        const seen = new Set([this.dataset.productId]);
        let count = 0;
        list.querySelectorAll('[data-record-id]').forEach(record => {
          if (record.dataset.recordArtist !== this.dataset.artist || seen.has(record.dataset.recordId) || count >= 4) {
            record.remove();
          } else {
            seen.add(record.dataset.recordId);
            count += 1;
          }
        });
        if (!count) return;
        this.querySelector('[data-artist-results]').replaceChildren(list);
        this.querySelector('[data-artist-panel]').hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') this.loaded = false;
      }
    }
  });
}
if (!customElements.get('bwr-dispatch-date')) {
  customElements.define('bwr-dispatch-date', class extends HTMLElement {
    connectedCallback() {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
      const day = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
      const weekday = day.getUTCDay();
      let days = (3 - weekday + 7) % 7;
      if (days === 0) days = 7;
      if (weekday === 2 && Number(parts.hour) >= 15) days += 7;
      day.setUTCDate(day.getUTCDate() + days);
      const label = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
      }).format(day);
      this.textContent = this.dataset.label.replace('[date]', label);
    }
  });
}
